import React from "react";
import { Select, Text, HStack, Spinner } from "@chakra-ui/react";
import { Link } from "react-router-dom";

/**
 * Reusable semester filter dropdown.
 * @param {{ cohortId: string, semesters: Array, selectedSemesterId: string, onChange: (id, dateRange) => void, loading: boolean }} props
 */
export default function SemesterFilterDropdown({
  cohortId,
  semesters = [],
  selectedSemesterId,
  onChange,
  loading,
  size = "sm",
}) {
  if (!cohortId) {
    return (
      <Select size={size} placeholder="Select cohort first" isDisabled bg="gray.700" borderColor="gray.600" />
    );
  }

  if (loading) {
    return (
      <HStack>
        <Spinner size="xs" />
        <Text fontSize="xs" color="gray.400">Loading semesters...</Text>
      </HStack>
    );
  }

  if (semesters.length === 0) {
    return (
      <HStack spacing={2}>
        <Select size={size} placeholder="No semesters defined" isDisabled bg="gray.700" borderColor="gray.600" />
        <Link to={`/admin/institution-config`} style={{ textDecoration: "none", whiteSpace: "nowrap" }}>
          <Text fontSize="xs" color="blue.300">Set up semesters</Text>
        </Link>
      </HStack>
    );
  }

  const formatRange = (s) => {
    const start = s.startDate ? new Date(s.startDate).toLocaleDateString() : "";
    const end = s.endDate ? new Date(s.endDate).toLocaleDateString() : "";
    return start && end ? ` (${start} - ${end})` : "";
  };

  const handleChange = (e) => {
    const id = e.target.value;
    if (!id) {
      onChange("", null);
      return;
    }
    const sem = semesters.find((s) => s.id === id);
    onChange(id, sem ? { startDate: sem.startDate, endDate: sem.endDate } : null);
  };

  return (
    <Select
      size={size}
      value={selectedSemesterId || ""}
      onChange={handleChange}
      bg="gray.700"
      borderColor="gray.600"
      placeholder="All Semesters"
    >
      {semesters.map((s) => (
        <option key={s.id} value={s.id}>
          {s.name}{formatRange(s)}
        </option>
      ))}
    </Select>
  );
}
